import React from "react";
import Img5 from "../../components/assets/test7.webp";
import { Link } from "react-router-dom";
import "./test.css";
const TestList = () => {
  return (
    <div id="test">
      <div className="container">
        <div className="row justify-content-center ">
          <div className="col-md-7 d-flex justify-content-center flex-column align-items-center pt-5 pt-lg-0 my-4">
            <h2 className="pb-1 fw-bold after position-relative">AI.Test</h2>
            <div className="w-sm-100 w-75 bgHome border-bottom border-opacity-25 border-secondary border-3 shadow rounded-4 p-3 mt-3 mb-4 ">
              <p>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                d.to join with us as a doctor click the link Doctors
              </p>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column align-items-center justify-conten-between ">
          <div className=" d-flex flex-column align-items-center justify-conten-between ">
            <div className="img-layer"></div>

            <div
              className="d-inline-block aft h-50 w-sm-100 w-75"
              style={{ position: "relative" }}
            >
              {" "}
              <a className="depression" href="any">
                Our Test
              </a>
              <img
                style={{ width: "100%" }}
                className="rounded-5 d-block  "
                src={Img5}
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center  ">
          <Link
            className="btn btn-primary px-5 mt-5 rounded-pill "
            to="testconfirm"
          >
            Start Test
          </Link>
        </div>
      </div>

      <div className="tests-list-content-footer    ">
        <div className="row justify-content-center m-5 mb-0">
          <div className="footer-title   my-3 ">
            <h5 className="text-center btn btn-lg  rounded-circle border text-primary bg-white border-primary">
              or
            </h5>
          </div>
          <div className="col-md-7 d-flex justify-content-center flex-column align-items-center px-2 pt-lg-0  ">
            <h2 className="pb-1 fw-bold after position-relative"
            style={{marginTop:"-15px"}}
            >
              Sychoclinic.AI
            </h2>
            <div className="box w-100 bgHome border-bottom border-opacity-25
             border-secondary border-3 shadow rounded-4 p-3 mt-1 mb-3 ">
              <p>
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                d.to join with us as a doctor click the link Doctors
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="btn btn-primary mt-3 py-2 fs-5 px-4 mb-5  fw-bold rounded-pill text-white">
              <Link className="text-white px-4 py-2" to="/chatbot">
                Try For Free
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestList;
